export default "__VITE_ASSET__Avbl8xtp__"